import { initials } from "@/lib/format";
import { cn } from "@/lib/utils";

export function InitialsAvatar({ name, size = "md", className }) {
    const sizes = {
        sm: "h-8 w-8 text-xs",
        md: "h-10 w-10 text-sm",
        lg: "h-12 w-12 text-base",
    };
    return (
        <span
            className={cn(
                "inline-flex shrink-0 items-center justify-center rounded-full bg-nm-accent font-semibold text-white",
                sizes[size],
                className
            )}
            aria-hidden="true"
        >
            {initials(name)}
        </span>
    );
}
